import React from 'react';
import CalendarConfig from '../../../../consts/CalendarConfig';
import styles from './textBodies.module.css';
import { classificationOf, diagnosesOfAppointment } from '../../../../pages/appointment/modules/diagnoses/diagnoses';

// Mesma limpeza do PatientHistoryItem: "\n" literal vira quebra de linha
const cleanText = (text) => (text || '').replace(/\n/g, '\n').trim();

/**
 * Miolo do PDF de evolução: um bloco por registro (data, quem registrou) com
 * a queixa, a evolução e os diagnósticos (CID) daquela consulta.
 *
 * `records`: registros do histórico, na ordem do card (sem os anulados);
 * `diagnoses`: diagnósticos do paciente (opcional), casados pelo atendimento.
 */
export const EvolutionReportBody = ({ records, diagnoses }) => {
  const list = Array.isArray(records) ? records : [];

  return (
    <>
      {list.map((record) => {
        const assessment = cleanText(record.assessment);
        const evolution = cleanText(record.evolution);
        const cids = diagnosesOfAppointment(diagnoses, record.appointmentId);
        return (
          <div key={record.id} className={styles.record}>
            <div className={styles.recordHead}>
              <span className={styles.recordDate}>{CalendarConfig.GetDDMMAAAA(record.createdAt)}</span>
              {record.createdByName && <span className={styles.recordMeta}>{record.createdByName}</span>}
              {record.replacesRecordId && <span className={styles.tag}>Registro corrigido</span>}
            </div>
            <span className={styles.label}>Queixa</span>
            <div className={assessment ? styles.text : styles.muted}>{assessment || 'Não informado'}</div>
            <span className={styles.label}>Evolução</span>
            <div className={evolution ? styles.text : styles.muted}>{evolution || 'Não informado'}</div>
            {cids.length > 0 && (
              <>
                <span className={styles.label}>Diagnósticos (CID)</span>
                {cids.map((diagnosis) => (
                  <div key={diagnosis.id} className={styles.text}>
                    <strong>{diagnosis.code}</strong> {diagnosis.title} <span className={styles.muted}>({classificationOf(diagnosis).label})</span>
                  </div>
                ))}
              </>
            )}
          </div>
        );
      })}
    </>
  );
};

export default EvolutionReportBody;
